<template>
  <div class="about-us">
    <!-- AboutUs Hero section -->
    <AboutHeroSection />
    <AboutNavSection />

    <!-- PESARO, ITALY -->
    <section class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden md:order-1 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/pesaro_italy.png`"
            image-class="self-center object-cover w-full h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center justify-start px-4 md:px-[30px] lg:px-0 bg-white overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] md:order-2 xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="uppercase text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] xl:text-[34px] xl:leading-[46px] font-ff-good-pro-cond font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_pesaro_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] text-secondary md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] font-normal font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_pesaro_description', {
                    brand_name: 'Benelli',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2018: The Birth of Benelli Bike -->
    <section id="about_2018" class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row bg-[#373737]">
        <div
          class="overflow-hidden md:order-2 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/2018_the_birthof_bbike.png`"
            image-class="self-center object-cover w-full h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-[346px] md:h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
          <div
            class="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full"
          >
            <PlayIcon
              class="cursor-pointer w-16 h-16 lg:w-[100px] lg:h-[100px] text-white rounded-full"
              style="
                fill: rgba(0, 0, 0, 0.4);
                backdrop-filter: blur(17.5px);
                background-color: rgba(255, 255, 255, 0.06);
              "
              @click.prevent="openLightbox(0, true)"
            />
          </div>
        </div>
        <div
          class="flex items-center justify-start md:justify-end px-4 md:px-[30px] lg:px-0 bg-[#373737] overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] md:order-1 xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5:leading-[46px] uppercase font-ff-good-pro-cond font-medium text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_2018_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] 1.5xl:text-[34px] 1.5xl:leading-[35px] font-normal text-white font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_2018_description', {
                    brand_name: 'Benelli Bike',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2020 Operation in Argentina & Equador  -->
    <section id="about_2020" class="relative">
      <div class="relative">
        <ImgLazyLoader
          :src="`/about-us${folderName}/2020.png`"
          image-class="order-1 md:h-[620px] lg:h-[700px] 1.5xl:h-[660px] 2xl:h-[700px] 2.5xl:h-[960px] 3xl:h-[1024px] object-cover w-full h-full bg-secondary"
          alt="BK"
        />
        <div
          class="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full"
        >
          <PlayIcon
            class="cursor-pointer w-16 h-16 lg:w-[100px] lg:h-[100px] text-white rounded-full"
            style="
              fill: rgba(0, 0, 0, 0.4);
              backdrop-filter: blur(17.5px);
              background-color: rgba(255, 255, 255, 0.06);
            "
            @click.prevent="openLightbox(1, true)"
          />
        </div>
      </div>

      <div
        class="-mt-1 xl:-mt-3 xl:px-4 bg-[#373737] pt-6 xl:pt-[60px] pb-[24px] xl:pb-[60px] md:pb-[40px] md:pt-[40px] lg:pb-[50px] lg:pt-[50px] order-2 w-full"
      >
        <div
          class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mx-auto mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
        />
        <div
          class="w-full lg:w-[784px] xl:w-[1214px] px-4 mt-[24px] md:max-w-7xl mx-auto md:px-16"
        >
          <p
            class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] 1.5xl:text-[34px] 1.5xl:leading-[35px] mt-[6px] md:mt-[6px] xl:text-[34px] text-center text-white font-ff-good-pro-cond font-normal xl:leading-[35px]"
            v-html="
              $t('common.about_us_2020_description', {
                brand_name: 'Benelli Bike',
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          />
        </div>
      </div>
    </section>

    <!-- BK 521 Cover  -->
    <section id="about_2020_2" class="relative">
      <ImgLazyLoader
        :src="`/about-us${folderName}/first_operation.png`"
        image-class="order-1 md:h-[620px] object-center md:object-top lg:object-center lg:h-[700px] 2xl:h-[960px] 3xl:h-[1024px] object-cover ob w-full h-full bg-secondary"
        alt="BK"
      />
      <div
        class="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full"
      >
        <PlayIcon
          class="cursor-pointer w-16 h-16 lg:w-[100px] lg:h-[100px] text-white rounded-full"
          style="
            fill: rgba(0, 0, 0, 0.4);
            backdrop-filter: blur(17.5px);
            background-color: rgba(255, 255, 255, 0.06);
          "
          @click.prevent="openLightbox(2, true)"
        />
      </div>
    </section>

    <!-- 2021: Expansion into Latin America -->
    <section id="about_2021" class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden px-[15px] md:px-0 pt-[15px] md:pt-0 md:order-1 order-2 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/2021.png`"
            image-class="self-center object-cover w-[345px] h-[325px] md:w-full md:h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center justify-start order-1 px-4 md:px-[30px] lg:px-0 bg-white overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] md:order-2 xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <div class="mb-[20px]">
              <Logo
                class="xl:w-[77px] xl:h-[70px] md:w-[48.4px] md:h-[44px] lg:w-[63.8px] lg:h-[58px] xyz-nested"
              />
            </div>
            <!-- w-[299px]  md:w-[270p] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="uppercase text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5xl:leading-[36px] font-ff-good-pro-cond font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_2021_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] 1.5xl:text-[34px] 1.5xl:leading-[35px] text-secondary font-normal font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_2021_description', {
                    brand_name: 'Benelli Bike',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2022: R-Line Leads the Carbon Frame Market -->
    <section id="about_2022" class="items-stretch lg:flex">
      <div
        class="w-full overflow-hidden md:flex md:flex-row px-4 md:px-0 pt-[15px] md:pt-0 bg-[#373737]"
      >
        <div
          class="overflow-hidden md:order-2 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/2022.png`"
            image-class="self-center object-cover w-full h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex md:items-center md:justify-end justify-start md:px-[30px] lg:px-0 bg-[#373737] overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] md:order-1 xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <div
              class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="uppercase text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5xl:leading-[36px] font-ff-good-pro-cond font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_2022_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] font-normal text-white font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_2022_description', {
                    brand_name: 'Benelli Bike',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Team of Benelli -->
    <section id="about_end_of_2022" class="relative">
      <ImgLazyLoader
        :src="`/about-us${folderName}/with_the_goal.png`"
        image-class="order-2 md:order-1 md:h-[620px] lg:h-[700px] 2xl:h-[960px] 3xl:h-[1024px] object-cover w-full h-[360px] bg-secondary"
        alt="BK"
      />
      <div
        class="-mt-1 xl:-mt-3 xl:px-4 order-1 md:order-2 bg-white pt-6 xl:pt-[60px] pb-[24px] xl:pb-[60px] md:pb-[40px] md:pt-[40px] lg:pb-[50px] lg:pt-[50px] w-full"
      >
        <div
          class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mx-auto mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
        />
        <div
          class="w-full lg:w-[784px] xl:w-[1214px] px-4 mt-[24px] mx-auto md:max-w-7xl md:px-16"
        >
          <p
            class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] mt-[6px] md:mt-[6px] text-center text-secondary font-ff-good-pro-cond font-normal"
            v-html="
              $t('common.about_us_team_description', {
                brand_name: 'Bbike',
                interpolation: { prefix: '[:', suffix: ']' },
              })
            "
          />
        </div>
      </div>
    </section>

    <!-- Benelli Bike Debuts at EICMA, Milan Fair -->
    <section id="about_end_of_2022" class="items-stretch lg:flex">
      <div
        class="w-full overflow-hidden md:flex md:flex-row px-4 md:px-0 pt-[15px] md:pt-0 bg-[#373737]"
      >
        <div
          class="overflow-hidden md:order-2 order-1 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/bbike_debuts.png`"
            image-class="self-center object-cover w-[345px] h-[325px] md:w-full md:h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center md:justify-end justify-start md:px-[30px] lg:px-0 bg-[#373737] overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] md:order-1 xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <div
              class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5xl:leading-[36px] font-ff-good-pro-cond uppercase font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_ecima_title', {
                  brand_name: 'Benelli Bike',
                  benelli_moto: 'Benelli Moto',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] text-white font-normal font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_ecima_description', {
                    benelli_moto: 'Benelli Moto',
                    brand_name: 'Benelli Bike',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2023: New Carbon Models Lead Global Expansion -->
    <section id="about_2023" class="items-stretch lg:flex">
      <div
        class="w-full overflow-hidden md:flex md:flex-row px-4 md:px-0 pt-[15px] md:pt-0"
      >
        <div
          class="overflow-hidden md:order-1 order-2 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/2023.png`"
            image-class="self-center object-cover w-full h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center order-2 md:order-1 justify-start md:px-[30px] lg:px-0 bg-white overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <div class="mb-[20px]">
              <BbikeLogo
                class="xl:w-[223px] md:w-[159px] w-[167.25px] h-[42px] md:h-[40px] lg:w-[183px] lg:h-[45px] xl:h-[56px] xyz-nested"
              />
            </div>
            <div
              class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="uppercase text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5xl:leading-[36px] xl:text-[34px] xl:leading-[36px] font-ff-good-pro-cond font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_2023_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] text-secondary font-normal font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_2023_description', {
                    brand_name: 'Benelli Bike',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 2024: A New Chapter for Benelli Bike -->
    <section id="about_2024" class="items-stretch lg:flex">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden px-4 md:px-0 pt-[15px] md:pt-0 bg-[#373737] md:order-2 order-1 flex items-center md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:flex md:w-1/2"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="50"
        >
          <ImgLazyLoader
            :src="`/about-us${folderName}/2024.png`"
            image-class="self-center object-cover w-full h-full mx-auto lg:object-right xyz-nested"
            alt="About Us Benelli Bike"
            class="flex items-center justify-center object-cover w-full h-[325px] md:h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center md:justify-end justify-start order-2 md:order-1 px-4 md:px-[30px] lg:px-0 bg-white overflow-hidden md:h-[500px] lg:h-[700px] 1.5xl:h-[670px] 3xl:h-[700px] 4xl:h-[750px] xl:py-8 md:w-1/2"
          data-aos="fade-left"
          data-aos-delay="10"
        >
          <div
            class="py-[30px] xl:pt-0 md:pb-[10px] lg:pb-[30px] xl:pb-0 xl:py-4 lg:ml-8 xl:mx-14 2xl:mx-[90px] 2xl:my-32 w-full lg:w-[448px] xl:w-[540px]"
          >
            <div
              class="border-b-4 xl:w-[108px] md:w-[77.353px] lg:w-[84px] w-[69px] h-1 lg:h-[4px] mb-[16px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />
            <!-- w-[299px]  md:w-[270px] lg:w-[340px] xl:w-[471px] xl:w-[510px] -->
            <h1
              class="uppercase text-[22px] leading-[30px] md:text-[26px] md:leading-[32px] lg:text-[30px] lg:leading-[36px] 1.5xl:text-[34px] 1.5xl:leading-[36px] xl:text-[34px] xl:leading-[36px] font-ff-good-pro-cond font-bold text-primary xl:tracking-normal md:mt-0 text-start"
              v-html="
                $t('common.about_us_2024_title', {
                  brand_name: 'Benelli Bike',
                  interpolation: { prefix: '[:', suffix: ']' },
                })
              "
            ></h1>
            <!-- xl:w-[525px]  -->
            <div class="mt-[10px]">
              <p
                class="text-[22px] leading-[26px] md:text-lg md:leading-[28px] lg:text-[28px] lg:leading-[32px] xl:text-[34px] xl:leading-[35px] text-secondary font-normal font-ff-good-pro-cond"
                v-html="
                  $t('common.about_us_2024_description', {
                    brand_name: 'Bbike',
                    keeway_brand: 'Keeway Group',
                    interpolation: { prefix: '[:', suffix: ']' },
                  })
                "
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About Us Gallery Modal -->
    <div class="aboutus-gallary">
      <Lightbox
        :items="videoGallery"
        :initialIndex="lightboxIndex"
        @update:visible="(e) => (lightboxIndex = e)"
      />
    </div>
  </div>
</template>

<script setup>
import { useTranslation } from "i18next-vue";
import { useMainStore } from "~/store";
import PlayIcon from "~/assets/svg/heroicons/play.svg?component";
import BbikeLogo from "~/assets/svg/footer-logo.svg?component";

const { t } = useTranslation();
const $config = useRuntimeConfig().public;
const store = useMainStore();

let controls = ref(false);
const lightboxIndex = ref(null);
const folderName = ref("/screen-1440");

const videoGallery = computed(() => {
  let videoArr = [
    {
      src: `${$config.CDN_DOMAIN}/gallery/R19_LaunchReel.mp4`,
      poster: `/about-us${folderName.value}/2020.png`,
      type: "video",
    },
    {
      src: `${$config.CDN_DOMAIN}/gallery/U19_LaunchReel.mp4`,
      poster: `/about-us${folderName.value}/first_operation.png`,
      type: "video",
    },
  ];
  if (process.browser && window.innerWidth >= 375 && window.innerWidth < 768) {
    videoArr = [
      {
        src: `${$config.CDN_DOMAIN}/gallery/R19_LaunchReel-mobile.mp4`,
        poster: `/about-us${folderName.value}/2020.png`,
        type: "video",
      },
      {
        src: `${$config.CDN_DOMAIN}/gallery/U19_LaunchReel-mobile.mp4`,
        poster: `/about-us${folderName.value}/first_operation.png`,
        type: "video",
      },
    ];
  }
  return [
    {
      src: `${$config.CDN_DOMAIN}/gallery/M19_LaunchReel.mp4`,
      poster: `/about-us${folderName.value}/2018_the_birthof_bbike.png`,
      type: "video",
    },
    ...videoArr,
  ];
});

if (process.browser) {
  if (window.innerWidth >= 375 && window.innerWidth < 768) {
    folderName.value = "/screen-375";
  } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
    folderName.value = "/screen-834";
  } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    folderName.value = "/screen-1204";
  } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    folderName.value = "/screen-1440";
  } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
    folderName.value = "/screen-1920";
  } else if (window.innerWidth >= 2500) {
    folderName.value = "/screen-2500";
  } else {
    folderName.value = "/screen-375";
  }

  window.addEventListener("resize", onResize);
}

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});

function openLightbox(index, isVideo) {
  lightboxIndex.value = index;
}

function countryWiseClass(defaultClass = "") {
  return store.country == "it" ? "h-auto" : defaultClass;
}
function showVideoControls() {
  controls.value = true;
}

function hideVideoControls() {
  controls.value = false;
}

function onResize() {
  if (window.innerWidth >= 375 && window.innerWidth < 768) {
    folderName.value = "/screen-375";
  } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
    folderName.value = "/screen-834";
  } else if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
    folderName.value = "/screen-1204";
  } else if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
    folderName.value = "/screen-1440";
  } else if (window.innerWidth >= 1920 && window.innerWidth < 2500) {
    folderName.value = "/screen-1920";
  } else if (window.innerWidth >= 2500) {
    folderName.value = "/screen-2500";
  } else {
    folderName.value = "/screen-375";
  }
}
</script>

<style lang="postcss">
.about-us__history {
  background-repeat: no-repeat;
  background-position: bottom center;
  @apply md:bg-cover;

  p {
    text-shadow: 2px 3px 5px rgba(0, 0, 0, 0.5);
  }
}
b {
  font-weight: 800;
}
.cool-lightbox {
  @apply !z-[99999999999];
}
.vue-lb-content {
  @apply max-w-none mb-0;
}
.vue-lb-header {
  @apply absolute z-10 right-2;
}
.cool-lightbox .cool-lightbox__iframe video {
  @apply !h-[95vh] !w-[97vw] object-cover rounded-[5px];
}
.cool-lightbox-toolbar__btn {
  @apply !fixed right-[1.5%] !top-[2.5%] z-[99999999];
}
.cool-lightbox-button {
  @apply !p-0  !w-[50px] !h-[50px];
}
.cool-lightbox .cool-lightbox-button.cool-lightbox-button--prev {
  @apply !left-[2.5%];
}
.cool-lightbox .cool-lightbox-button.cool-lightbox-button--next {
  @apply !right-[2.5%];
}
.cool-lightbox__slide__img {
  @apply !h-[95vh] !w-[97vw];
}
.cool-lightbox__slide__img img {
  @apply !h-[95vh] !w-auto !object-contain;
}
.cool-lightbox-toolbar .cool-lightbox-toolbar__btn {
  @apply !bg-transparent;
}
.cool-lightbox .cool-lightbox__slide img {
  @apply !shadow-none;
}
.controls {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0px 0px 2px 2px;
  backdrop-filter: blur(12.5px);
  @apply w-[97vw] gap-2 lg:gap-6 px-2 md:px-5 h-10 left-[1.47%]  right-[1.5%] justify-between items-center fixed bottom-[2.5%] z-[999999999999];
}
.controls[data-state="hidden"] {
  display: none;
}

.controls[data-state="visible"] {
  display: block;
}
.controls > * {
  @apply block h-5;
}

.controls > *:first-child {
  margin-left: 0;
}
.controls .progress {
  @apply cursor-pointer w-full rounded-full h-2;
}
.controls button {
  border: none;
  cursor: pointer;
  background: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  @apply !min-w-[20px] h-5;
}
.controls button:hover,
.controls button:focus {
  opacity: 0.5;
}
#remaining-time {
  min-width: 47px;
}
.controls progress {
  /* -moz-border-radius: 100%; */
  /* -webkit-border-radius: 100%; */
  @apply rounded-full overflow-hidden text-[#0095dd] border-none w-full h-full block relative;
}
.controls progress[data-state="fake"] {
  background: #e6e6e6;
  height: 65%;
}
.controls progress span {
  width: 0%;
  height: 100%;
  display: inline-block;
  background-color: #2a84cd;
}
.controls #progress-dot {
  width: 20px;
  height: 20px;
  left: -10px;
  position: absolute;
  top: -6px;
  z-index: 9999999999999;
  background: white;
  border-radius: 100%;
}
.controls progress::-moz-progress-bar {
  background-color: #0095dd;
}

.controls progress::-webkit-progress-value {
  background-color: #0095dd;
}
figure[data-fullscreen="true"] video::-webkit-media-controls {
  display: none !important;
}
figure[data-fullscreen="true"] .controls {
  z-index: 2147483647;
}
.about-us strong {
  @apply text-primary;
}
</style>
